import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Properties } from 'src/app/app-config/properties';
import { StorageService } from './storage.service';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { Observable, lastValueFrom, throwError } from 'rxjs';
import { USERROLE } from 'src/util/constant';

@Injectable({
  providedIn: 'root',
})
export class SettingService {

  // isIdle: boolean;
  // public maxIdleTime: number = 60000;
  // public idleTimeCounter: any = 0;
  // public idleTimeOut: any = 0;

  constructor(
    private http: HttpClient,
    private store: StorageService
  ) { }

  fetchSettings(): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this.http.get(Properties.SETTINGS_API_ENDPOINT, options).pipe(
      timeout(50000),
      map((response: { [key: string]: any }) => {
        if (response.code == 0) {
          this.store.setBaseSettings(response);
          return response;
        }
      }),
      catchError((e) => {
        return throwError(() => new Error(`${e.status} ${e.statusText}`));
      })
    );
  }

  getComponentConfig(filename: string) {
    return this.http
      .get(`${Properties.GET_CONFIG_API_ENDPOINT}${filename}.json`, {
        responseType: 'text' as 'text',
      })
      .pipe(
        timeout(50000),
        map((response: any) => {
          const res: any = JSON.parse(response);
          if (res.code == 0) {
            return res;
          }
        }),
        catchError((e) => {
          return throwError(() => new Error(`${e.status} ${e.statusText}`));
        })
      );
  }

  async getLinkProjectConfiguration(projectName: string) {
    try {
      const response = this.http.get(`${Properties.GET_CONFIG_API_ENDPOINT}${projectName}.json`,
        {
          responseType: 'text' as 'text',
        });

      return await lastValueFrom(response);
    } catch (e) {

    }
  }

  getNonAsyncLinkProjectConfiguration(projectName: string) {
    return JSON.stringify({
      "code": 0,
      "description": "Success",
      "config": {
        "regex": "^[s,j][s]\\.\\d{4,5}$",
        "flag": "i",
        "price": 1500,
        "placeholder": "SS.3409",
        "name": "staff"
      }
    });
  }

  getTranslation(filename: string) {
    return this.http
      .get(`${Properties.GET_CONFIG_API_ENDPOINT}${filename}.json`, {
        responseType: 'text' as 'text',
      })
      .pipe(
        timeout(50000),
        map((response: any) => {
          const res: any = JSON.parse(response);
          if (res.metadata) {
            return res;
          }
        }),
        catchError((e) => {
          return throwError(() => new Error(`${e.status} ${e.statusText}`));
        })
      );
  }

  getComponentSettings(
    productId: string,
    componentName: string
  ): Observable<any> {
    let options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .get(
        `${Properties.GET_COMPONENT_SETTING_ENDPOINT}?componentName=${componentName}&productId=${productId}`,
        options
      )
      .pipe(
        timeout(50000),
        map((response: Response) => {
          return response;
        }),
        catchError((e) => {
          return throwError(() => new Error(`${e.status} ${e.statusText}`));
        })
      );
  }

  getApplicationSettings() {
    const authDetails = this.store.getUserAuthorizationDetails();
    let actions = {
      canRefresh: false,
      canDelete: false,
      canGenerate: false,
      canBulkDownload: false,
      canBulkGenerate: false,
      canDownload: false,
      canViewSettings: false,
      canChangeExpiration: false,
      canViewCardActivityLog: false,
      canResetForDataCapture: false,
      canResetForPhotoCapture: false,
      canBlacklist: false,
      canGenerateAndDownload: false,
      canResetCardForPDFGeneration: false,
      canUpdateUserDetails: false,
      canReconcilePayment: false,
      canMergeMultipleCards: false,
    };
    switch (authDetails.role) {
      case USERROLE.SUPERADMIN:
        actions.canRefresh = true;
        actions.canDelete = true;
        actions.canGenerate = true;
        actions.canBulkDownload = true;
        actions.canBulkGenerate = true;
        actions.canDownload = true;
        actions.canViewSettings = true;
        actions.canChangeExpiration = true;
        actions.canViewCardActivityLog = true;
        actions.canResetForPhotoCapture = true;
        actions.canResetForDataCapture = true;
        actions.canBlacklist = true;
        actions.canGenerateAndDownload = true;
        actions.canResetCardForPDFGeneration = true;
        actions.canUpdateUserDetails = true;
        actions.canReconcilePayment = true;
        actions.canMergeMultipleCards = true;
        break;
      case USERROLE.ADMIN:
        actions.canRefresh = true;
        actions.canDelete = true;
        actions.canGenerate = true;
        actions.canBulkDownload = true;
        actions.canDownload = true;
        actions.canViewSettings = true;
        actions.canChangeExpiration = true;
        actions.canViewCardActivityLog = true;
        actions.canResetForPhotoCapture = true;
        actions.canResetForDataCapture = true;
        actions.canGenerateAndDownload = true;
        actions.canResetCardForPDFGeneration = true;
        actions.canUpdateUserDetails = true;
        actions.canMergeMultipleCards = true;
        break;
      case USERROLE.USER:
        actions.canRefresh = true;
        actions.canDownload = true;
        actions.canResetForPhotoCapture = true;
        actions.canResetForDataCapture = true;
        actions.canGenerateAndDownload = true;
        break;
      case USERROLE.PRINTER:
        actions.canRefresh = true;
        actions.canBulkDownload = true;
        actions.canDownload = true;
        break;
    }

    return actions;
  }

}
